// Validates keyboard input based on allowed keys and a validation pattern
export const validateKeyInput = (e, validationPattern) => {
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
  if (allowedKeys.includes(e.key)) {
    return true;
  }

  if (e.ctrlKey && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
    return true;
  }

  if (validationPattern && validationPattern.test(e.key)) {
    return true;
  }

  e.preventDefault();
  return false;
};

